module.exports = __webpack_public_path__ + "static/media/GOLDBEES.7858adb6.txt";